var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal, "max-width": "1320px", persistent: "" },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Voltar ")]
              ),
              _c(
                "BaseButton",
                { attrs: { primary: "" }, on: { click: _vm.enviar } },
                [_vm._v(" Inserir ativo ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Lista completa" } }),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { class: _vm.ativosSelecionados.length ? "col-8" : "col-12" },
          [
            _c(
              "div",
              { staticClass: "d-flex row mb-0 pb-0" },
              [
                _c("v-select", {
                  staticClass: "col-3 pb-0",
                  attrs: { label: "Tipo", items: ["Todos"].concat(_vm.tipos) },
                  on: {
                    change: function($event) {
                      return _vm.loadAssets(true)
                    }
                  },
                  model: {
                    value: _vm.filtro.tipo,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "tipo", $$v)
                    },
                    expression: "filtro.tipo"
                  }
                }),
                _c("v-select", {
                  staticClass: "col-3 pb-0",
                  attrs: {
                    label: "Classe",
                    items: ["Todas"].concat(_vm.CLASSES_SIMULADOR)
                  },
                  on: {
                    change: function($event) {
                      return _vm.loadAssets(true)
                    }
                  },
                  model: {
                    value: _vm.filtro.classe,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "classe", $$v)
                    },
                    expression: "filtro.classe"
                  }
                }),
                _c("v-select", {
                  staticClass: "col-3 pb-0",
                  attrs: {
                    label: "Subclasse",
                    items: ["Todas"].concat(_vm.subclasses),
                    "item-text": "subclasse",
                    "item-value": "subclasse"
                  },
                  on: {
                    change: function($event) {
                      return _vm.loadAssets(true)
                    }
                  },
                  model: {
                    value: _vm.filtro.subclasse,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "subclasse", $$v)
                    },
                    expression: "filtro.subclasse"
                  }
                }),
                _c("v-select", {
                  staticClass: "col-3 pb-0",
                  attrs: { label: "Na base", items: ["Todos", "Sim", "Não"] },
                  on: {
                    change: function($event) {
                      return _vm.loadAssets(true)
                    }
                  },
                  model: {
                    value: _vm.filtro.utilizar,
                    callback: function($$v) {
                      _vm.$set(_vm.filtro, "utilizar", $$v)
                    },
                    expression: "filtro.utilizar"
                  }
                })
              ],
              1
            ),
            _c(
              "form",
              {
                staticClass: "my-5",
                attrs: { action: "#" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "input-group align-items-center" },
                  [
                    _c("v-text-field", {
                      staticClass: "input short-search",
                      attrs: {
                        "append-icon": " ",
                        "background-color": "#E4E0E6",
                        "item-value": "id",
                        "item-text": "name",
                        label: "",
                        "full-width": "",
                        placeholder: "Pesquisar"
                      },
                      model: {
                        value: _vm.searchAsset,
                        callback: function($$v) {
                          _vm.searchAsset = $$v
                        },
                        expression: "searchAsset"
                      }
                    }),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-icon btn-icon-secondary align-self-center",
                        style: {
                          "background-color": "#E4E0E6"
                        }
                      },
                      [
                        _c("icon-svg", {
                          attrs: {
                            color: "#7C89B7",
                            size: "18",
                            name: "status-search"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "tabela-ativos" },
              [
                _c("v-data-table", {
                  staticClass: "table-pointer",
                  staticStyle: { background: "transparent" },
                  attrs: {
                    height: "220",
                    "fixed-header": "",
                    "sort-by": _vm.sortBy,
                    "sort-desc": _vm.sortDesc,
                    "item-key": "id_ativo",
                    items: _vm.ativos,
                    headers: _vm.headers,
                    loading: _vm.loadingAssets,
                    "items-per-page": _vm.itensPorPagina,
                    "footer-props": {
                      "items-per-page-options": [10, 50, 100, 250]
                    },
                    "server-items-length": _vm.totalResult,
                    page: _vm.paginaAtual
                  },
                  on: {
                    "update:sortBy": function($event) {
                      _vm.sortBy = $event
                    },
                    "update:sort-by": [
                      function($event) {
                        _vm.sortBy = $event
                      },
                      function($event) {
                        return _vm.loadAssets(true)
                      }
                    ],
                    "update:sortDesc": function($event) {
                      _vm.sortDesc = $event
                    },
                    "update:sort-desc": [
                      function($event) {
                        _vm.sortDesc = $event
                      },
                      function($event) {
                        return _vm.loadAssets(true)
                      }
                    ],
                    "update:itemsPerPage": function($event) {
                      _vm.itensPorPagina = $event
                    },
                    "update:items-per-page": [
                      function($event) {
                        _vm.itensPorPagina = $event
                      },
                      function($event) {
                        _vm.itensPorPagina = $event
                        _vm.loadAssets(true)
                      }
                    ],
                    "update:page": function($event) {
                      _vm.paginaAtual = $event
                      _vm.loadAssets(true)
                    },
                    "click:row": _vm.selectAsset
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "item.aberto",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                small: "",
                                color: value ? "success" : "red"
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    value
                                      ? "mdi-lock-open-outline"
                                      : "mdi-lock-outline"
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }
                    },
                    {
                      key: "item.utilizar",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c("div", { class: { "text-success": value } }, [
                            _vm._v(" " + _vm._s(value ? "Sim" : "Não") + " ")
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.nome_ativo",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c("div", { staticClass: "asset-name-cell" }, [
                            _vm._v(_vm._s(value || "-"))
                          ])
                        ]
                      }
                    },
                    {
                      key: "item.recomendacao",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          value
                            ? _c("BaseStatus", {
                                attrs: {
                                  soft: "",
                                  content: _vm.getRecomendacaoLabel(value),
                                  color: _vm.getRecomendacaoStatusColor(value)
                                }
                              })
                            : _c("small", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.setor",
                      fn: function(ref) {
                        var value = ref.value
                        return [_c("small", [_vm._v(_vm._s(value || "-"))])]
                      }
                    },
                    {
                      key: "item.tags",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          Array.isArray(value) && value.length
                            ? _c("ClientTags", {
                                attrs: {
                                  tags: value,
                                  "max-tags-display": 2,
                                  "color-mode": "fixed",
                                  "use-small-chips": ""
                                }
                              })
                            : _c("small", [_vm._v("-")])
                        ]
                      }
                    },
                    {
                      key: "item.comentario",
                      fn: function(ref) {
                        var value = ref.value
                        return [
                          _c("icon-svg", {
                            attrs: {
                              color: value ? "var(--primary)" : "#A4A4A4",
                              size: "16",
                              name: "message-time"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]
        ),
        _vm.ativosSelecionados.length
          ? _c(
              "div",
              { staticClass: "col-4" },
              [
                _c("p", { staticClass: "subhead text-bold" }, [
                  _vm._v(" Ativos selecionados ")
                ]),
                _c("v-divider"),
                _c(
                  "v-list",
                  [
                    _c(
                      "v-list-item-group",
                      {
                        staticStyle: {
                          "max-height": "300px",
                          "overflow-y": "auto"
                        }
                      },
                      _vm._l(_vm.ativosSelecionados, function(a) {
                        return _c(
                          "v-list-item",
                          {
                            key: a.id_ativo,
                            on: {
                              click: function($event) {
                                return _vm.openEdit(a)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-content-between",
                                      staticStyle: { "max-width": "100%" }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "selected-asset-name" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(a.nome_ativo || "—") +
                                              " "
                                          )
                                        ]
                                      ),
                                      _vm.getNumber(a.percentual)
                                        ? _c("small", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  a.percentual +
                                                    ((a.percentual || "")
                                                      .toString()
                                                      .includes("%")
                                                      ? ""
                                                      : "%")
                                                ) +
                                                " "
                                            )
                                          ])
                                        : _c("small", [
                                            _vm._v(" " + _vm._s(a.pl) + " ")
                                          ])
                                    ]
                                  )
                                ]),
                                _c("v-list-item-subtitle", [
                                  _c("small", [
                                    _vm._v(" " + _vm._s(a.classe) + " ")
                                  ])
                                ]),
                                _c("hr")
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-action",
                              { staticClass: "ml-1" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { small: "", icon: "" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deselect(a)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v(" mdi-close ")
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _c("EditarAtivo", {
        attrs: {
          bus: _vm.busModal,
          "pl-total": _vm.plTotal,
          "pl-sugerido": _vm.plSugerido,
          "pl-nao-alocado": _vm.plNaoAlocado,
          "ativos-atuais": _vm.ativosAtuais,
          janelaTempo: _vm.janelaTempo,
          qualificado: _vm.qualificado,
          classes: _vm.classes,
          ativosSelecionados: _vm.ativosSelecionados
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }